import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import Small from 'UIComponents/elements/Small';
import Big from 'UIComponents/elements/Big';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { getDisplayPercentage } from './utils/formattingUtils';
import { EMPTY_VALUE } from '../../constants/constants';
import { AttainmentBarName } from './AttainmentBarName';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultRenderValue = value => /*#__PURE__*/_jsx("div", {
  children: /*#__PURE__*/_jsx(FormattedNumber, {
    value: value
  })
});
const defaultRenderGoal = goal => /*#__PURE__*/_jsx("div", {
  children: goal ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "attainmentBar.goal",
    options: {
      value: goal
    }
  }) : EMPTY_VALUE
});
export const AttainmentBar = ({
  avatarSize = 'xs',
  email,
  goal,
  height = 10,
  isPercentageBig = false,
  name,
  onClickAttainmentBar,
  renderGoal = defaultRenderGoal,
  renderValue = defaultRenderValue,
  showAvatar = true,
  showClosedAmountSection = false,
  showPercentage = true,
  showSubtext = true,
  tooltipProps = {
    children: /*#__PURE__*/_jsx(_Fragment, {})
  },
  value
}) => {
  const AttainmentBarWrapper = styled.div.withConfig({
    displayName: "AttainmentBar__AttainmentBarWrapper",
    componentId: "kqwgyk-0"
  })(["flex-grow:1;cursor:", ";"], onClickAttainmentBar ? 'pointer' : 'auto');
  const attainmentPercentage = goal ? value / goal * 100 : undefined;
  const hasAttainerInfo = name || email;
  const showPercentageInLine = !hasAttainerInfo && showPercentage;
  let percentage;
  if (showPercentage) {
    percentage = isPercentageBig ? /*#__PURE__*/_jsxs(Big, {
      children: [" ", getDisplayPercentage(attainmentPercentage)]
    }) : getDisplayPercentage(attainmentPercentage);
  }
  const attainmentBarHeight = showClosedAmountSection ? 5 : height;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasAttainerInfo && /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      blockSize: "1000",
      justifyContent: "space-between",
      "data-test-id": "attainer-info",
      marginBlockEnd: "200",
      children: [showAvatar ? /*#__PURE__*/_jsx(AttainmentBarName, {
        email: email,
        name: name,
        avatarSize: avatarSize
      }) : /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx("b", {
          children: name
        })
      }), showPercentage && /*#__PURE__*/_jsx(Box, {
        basis: 10,
        "data-test-id": "attainer-info-percentage",
        grow: 1,
        marginInlineEnd: "200",
        children: percentage
      })]
    }), showClosedAmountSection && /*#__PURE__*/_jsx(UIFlex, {
      align: "end",
      justify: "end",
      "data-test-id": "closed-amount-section",
      children: renderValue(value)
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(AttainmentBarWrapper, {
        children: /*#__PURE__*/_jsx(Tooltip, Object.assign({
          disabled: tooltipProps && !tooltipProps.title
        }, tooltipProps, {
          children: /*#__PURE__*/_jsx(Progress, {
            blockSize: `${attainmentBarHeight}px`,
            "data-test-id": "attainment-bar",
            marginBlockEnd: "200",
            marginInlineEnd: "200",
            onClick: onClickAttainmentBar,
            value: attainmentPercentage
          })
        }))
      }), showPercentageInLine && /*#__PURE__*/_jsx(Box, {
        "data-test-id": "inline-percentage",
        marginBlockEnd: "200",
        grow: 0,
        children: percentage
      })]
    }), showSubtext && /*#__PURE__*/_jsxs(UIFlex, {
      "data-test-id": "attainment-bar-subtext",
      children: [/*#__PURE__*/_jsx(UIBox, {
        shrink: 0,
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          "data-test-id": "attainment-closed",
          children: renderValue(value)
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        grow: 1
      }), /*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(Small, {
          "data-test-id": "attainment-goal",
          children: renderGoal(goal)
        })
      })]
    })]
  });
};